import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import * as typography from "@universityofmaryland/web-styles-library/typography";
import { theme } from "@universityofmaryland/web-utilities-library/theme";
import { createCompositeQuoteIcon } from "./icon.js";
import { SMALL } from "../_constants.js";
const splitWords = (quote) => {
  const text = quote.textContent ?? "";
  const words = text.trim().split(/\s+/);
  const wordElements = words.map((word, index) => {
    const wordElement = document.createElement("span");
    wordElement.classList.add("quote-text-split-word");
    Object.assign(wordElement.style, {
      display: "inline-block",
      whiteSpace: "pre-wrap",
      opacity: "0",
      transform: "translateY(20px)",
      transition: "opacity 1s ease, transform 0.5s ease"
    });
    wordElement.textContent = word + (index < words.length - 1 ? " " : "");
    return wordElement;
  });
  return wordElements;
};
const CreateQuoteElement = (props) => {
  const {
    hasImage = false,
    includesAnimation = false,
    isSizeLarge = false,
    isThemeMaryland = false,
    isTypeFeatured = false,
    quote,
    shouldHaveWhiteText = false
  } = props;
  const isHasImageAndNotFeatured = hasImage && !isTypeFeatured;
  const iconSpan = createCompositeQuoteIcon(props);
  const wordsList = splitWords(quote);
  let quoteTextElement = quote;
  if (includesAnimation) {
    quoteTextElement = document.createElement("div");
    wordsList.map((word) => {
      quoteTextElement.appendChild(word);
    });
  }
  const fontStyles = isSizeLarge ? typography.sans.compose("extralarge", {
    theme: theme.fontColor(shouldHaveWhiteText)
  }) : typography.sans.compose("larger", {
    theme: theme.fontColor(shouldHaveWhiteText)
  });
  const builder = new ElementBuilder(quoteTextElement).styled(fontStyles).withClassName("quote-container-quote").withStyles({
    element: {
      position: "relative",
      fontWeight: "700",
      ["& *"]: {
        color: "currentColor"
      },
      [`&::before`]: {
        content: '""',
        position: "absolute",
        left: `-${token.spacing.md}`,
        top: "7px",
        height: "calc(100% - 14px)",
        width: "2px",
        display: "block",
        backgroundColor: token.color.red,
        ...isThemeMaryland && { backgroundColor: token.color.gold },
        ...isHasImageAndNotFeatured && {
          display: "none"
        },
        [`@container (min-width: ${SMALL}px)`]: {
          left: `-${token.spacing.md}`
        },
        [`@container (max-width: ${SMALL - 1}px)`]: {
          ...!isTypeFeatured && {
            display: "block"
          }
        }
      }
    }
  });
  if (!hasImage) {
    builder.withChild(iconSpan);
  }
  return builder.build();
};
const CreateStatementQuoteElement = ({ quote }) => new ElementBuilder(quote).withClassName("statement-quote").withStyles({
  element: {
    color: token.color.gray.dark,
    lineHeight: token.spacing.md,
    fontSize: token.font.size.base,
    textAlign: "left"
  }
}).build();
const createCompositeQuote = CreateQuoteElement;
const createStatementQuote = CreateStatementQuoteElement;
export {
  createCompositeQuote,
  createStatementQuote
};
//# sourceMappingURL=quote.js.map
